
<div v-if="solde" :class="jel_getClassObject(content)">
  <Titre
    :content="{
      type: content.type,
      titre: titreFormatte,
      classeCSS: 'text-center text-md-left mb-1 pt-1',
    }"
  >
  </Titre>
</div>
